export const BASE_URL = `https://www.omdbapi.com/`;
export const DEFAULT_URL = `/`;
